<div class="updating-sheet-dialog">
  <div class="dialog-content">
    <!-- Loading State -->
    <div *ngIf="!isCompleted" class="loading-state">
      <mat-spinner diameter="60" strokeWidth="4"></mat-spinner>
      <h2 class="dialog-title">{{ message }}</h2>
      <div class="progress-tracking">
        <div class="progress-item" *ngIf="publishedTotal > 0">
          <p>{{ publishedCount }} of {{ publishedTotal }} Updated</p>
        </div>
        <div class="progress-item" *ngIf="deletedTotal > 0">
          <p>{{ deletedCount }} of {{ deletedTotal }} deleted</p>
        </div>
        <div class="progress-item" *ngIf="errorTotal > 0">
          <p>{{ errorCount }} of {{ errorTotal }} errors</p>
        </div>
        <div class="progress-item" *ngIf="apiErrorTotal > 0">
          <p>{{ apiErrorCount }} of {{ apiErrorTotal }} API errors</p>
        </div>
      </div>
    </div>

    <!-- Success State -->
    <div *ngIf="isCompleted" class="success-state">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <h2 class="dialog-title success-title">{{ successMessage }}</h2>
      <div class="record-count" *ngIf="totalRecords > 0">
        <p>Successfully updated {{ totalRecords }} of {{ totalRecords }} records</p>
      </div>
      <button (click)="onOkClick()" class="ok-button">OK</button>
    </div>
  </div>
  <div class="loader-note"> <span class="font-semibold">Note: </span> <span class="italic">Please do not close until the process is completed.</span> </div>
</div>
